import { firebaseAction } from 'vuexfire'
import db from '@/plugins/db'
import firebase from 'firebase/app'
import { findKey } from 'lodash'

// initial state
const state = {
  all: {},
  questionAnswers: {},
  hourAnswers: {},
}

// getters
const getters = {
  getAll: (state) => () => {
    if (state.all === null) {
      return []
    }

    return Object.values(state.all)
  },
  getAnswersForHour: (state) => (hourNumber) => {
    if (!hourNumber) return undefined
    if (!state.hourAnswers) return undefined

    return state.hourAnswers
  },
  getQuestionAnswers: (state) => (hourNumber, questionNumber) => {
    if (!hourNumber || !questionNumber) return undefined
    if (!state.questionAnswers) return undefined

    return state.questionAnswers
  },
}

// actions
const actions = {
  bindAnswers: firebaseAction(context => {
    return context.bindFirebaseRef('all', db.ref('answers'))
  }),
  bindQuestionAnswers: firebaseAction((context, { hourNumber, questionNumber }) => {
    return context.bindFirebaseRef('questionAnswers', db.ref(`answers/hour${hourNumber}/question${questionNumber}`))
  }),
  bindHourAnswers: firebaseAction((context, hourNumber) => {
    return context.bindFirebaseRef('hourAnswers', db.ref(`answers/hour${hourNumber}`))
  }),
  add: ({ commit }, { hourNumber, questionNumber, answer }) => {
    answer.submittedAt = firebase.database.ServerValue.TIMESTAMP
    db.ref(`answers/hour${hourNumber}/question${questionNumber}/submissions`).push(answer)
  },
  addNote: ({ commit }, { hourNumber, questionNumber, answer }) => {
    answer.submittedAt = firebase.database.ServerValue.TIMESTAMP
    db.ref(`answers/hour${hourNumber}/question${questionNumber}/notes`).push(answer)
  },
  correct: ({ commit }, { hourNumber, questionId, answer }) => {
    answer.calledInAt = firebase.database.ServerValue.TIMESTAMP
    let updates = {
      solution: answer,
      closedAt: firebase.database.ServerValue.TIMESTAMP,
      open: false,
      correct: true,
    }
    db.ref(`questions/hour${hourNumber}/${questionId}`).update(updates)
  },
  setSolution: ({ commit }, { hourNumber, questionNumber, answer }) => {
    answer.calledInAt = firebase.database.ServerValue.TIMESTAMP
    let answerKey = findKey(state.hourAnswers[`question${questionNumber}`]['submissions'], ['text', answer.text])
    db.ref(`answers/hour${hourNumber}/question${questionNumber}/submissions/${answerKey}`).update(answer)
  },
  updateAnswer: ({ commit }, { hourNumber, questionNumber, answer, newProps }) => {
    let answerKey = findKey(state.hourAnswers[`question${questionNumber}`]['submissions'], ['text', answer.text])
    db.ref(`answers/hour${hourNumber}/question${questionNumber}/submissions/${answerKey}`).update(newProps)
  },
  addToIncorrects: ({ commit }, { hourNumber, questionNumber, answer }) => {
    // A one word submission from a processed partial might already have a TIMESTAMP.
    // If it's already set, VUE throws a warning and error.
    if (answer.calledInAt == null) {
      answer.calledInAt = firebase.database.ServerValue.TIMESTAMP
    }
    db.ref(`answers/hour${hourNumber}/question${questionNumber}/incorrects`).push(answer)
  },
  markForDeletion: ({ commit }, { hourNumber, questionNumber, answer }) => {
    let answerKey = findKey(state.hourAnswers[`question${questionNumber}`]['submissions'], ['text', answer.text])
    answer.toBeDeleted = true
    db.ref(`answers/hour${hourNumber}/question${questionNumber}/submissions/${answerKey}`).update(answer)
  },
  updateNoteRelevance: ({ commit }, { hourNumber, questionNumber, answerKey, relevance }) => {
    db.ref(`answers/hour${hourNumber}/question${questionNumber}/notes/${answerKey}`).update({ relevance: relevance })
  },
  removeSubmission: ({ commit }, { hourNumber, questionNumber, text }) => {
    let answerKey = findKey(state.hourAnswers[`question${questionNumber}`]['submissions'], ['text', text])
    db.ref(`answers/hour${hourNumber}/question${questionNumber}/submissions/${answerKey}`).remove()
  },
}

// mutations
const mutations = {

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
